import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentAccessTypesComponent } from './document-access-types.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddDocumentAccessTypesComponent } from './add-document-access-types/add-document-access-types.component';
import { EditDocumentAccessTypesComponent } from './edit-document-access-types/edit-document-access-types.component';

@NgModule({
    declarations: [
        DocumentAccessTypesComponent,
        AddDocumentAccessTypesComponent,
        EditDocumentAccessTypesComponent,
    ],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
    exports: [DocumentAccessTypesComponent],
})
export class DocumentAccessTypesModule { }
